import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  menu: {
    "& .MuiList-padding": {
      padding: 0,
    },
    "& .MuiMenu-paper": {
      width: "475px",
      maxHeight: "640px",

      [theme.breakpoints.down("sm")]: {
        width: "100vw",
        maxWidth: "100vw",
        left: "0 !important",
        maxHeight: "calc(var(--vh) - 72px)",
      },
    },
  },
  headerContainer: {
    position: "sticky",
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 2,
    padding: "18px 16px 14px",
    borderBottom: "1px solid rgba(0,0,0,0.12)",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "start",
    },
  },
}));

export default useStyles;
